import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=10b90af2&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/fared/kowamas-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b90af2')) {
      api.createRecord('10b90af2', component.options)
    } else {
      api.reload('10b90af2', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=10b90af2&", function () {
      api.rerender('10b90af2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/profile/Profile.vue"
export default component.exports